import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AirplaneTakeOffStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M7.096 5.00031C7.2113 4.96206 7.3351 4.9519 7.45611 4.97214L14.8815 6.21376L16.7593 5.07126L16.7758 5.06159L16.7933 5.05165C17.8499 4.48217 19.2537 4.28137 20.3407 4.51832L20.3416 4.51806L21.6227 4.78723L21.641 4.79125L21.6596 4.79621C23.253 5.21674 23.5854 7.27577 22.2653 8.19168L22.256 8.19832L22.2457 8.20522L17.7505 11.1145L14.4708 19.0184C14.4093 19.1664 14.3016 19.2917 14.1643 19.3743L11.4378 21.0153C11.1946 21.1617 10.8893 21.1574 10.6495 21.0054C10.4097 20.8535 10.276 20.579 10.3044 20.2966L10.849 14.8916L6.69633 16.7366C6.47464 16.8351 6.21888 16.8198 6.01007 16.6963L1.25161 13.884C1.02224 13.7482 0.881874 13.5008 0.883425 13.2343C0.885064 12.9674 1.0289 12.7212 1.26025 12.5882L3.64175 11.2195L3.71189 11.1838C3.87873 11.11 4.06779 11.0996 4.2433 11.1556L5.89746 11.6839L9.14137 9.70944L5.16075 7.2849C4.92994 7.14439 4.79215 6.89081 4.80072 6.62075C4.80946 6.3506 4.96289 6.10538 5.20232 5.97997L6.98446 5.04754L7.096 5.00031ZM20.0266 5.98417C19.309 5.82603 18.2718 5.96202 17.5147 6.36641L6.38641 13.1434C6.20077 13.2564 5.97532 13.283 5.76829 13.2169L4.10169 12.684L3.12207 13.2473L6.43967 15.2085L10.9794 13.192L11.0986 12.4321L11.1365 12.2877C11.2547 11.966 11.5825 11.758 11.9353 11.8031C12.3382 11.8548 12.6266 12.2184 12.5858 12.6226L11.9461 18.9572L13.1793 18.216L16.4562 10.324L16.508 10.2224C16.5664 10.1261 16.646 10.0439 16.7413 9.98217L21.4156 6.95515C21.6864 6.76134 21.6192 6.34434 21.2862 6.24917L20.0333 5.98637L20.0266 5.98417ZM7.07315 6.69332L10.5837 8.83095L12.9226 7.40719L7.45621 6.49253L7.07315 6.69332Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AirplaneTakeOffStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AirplaneTakeOffStrokeIcon;
